export enum ModHistoryType {
  BillingPlan = "BILLINGPLAN",
  AbstractContract = "ABSTRACTCONTRACT",
  ContractBillingPlan = "CONTRACTBILLINGPLAN",
  ClinBillingPlan = "CLINBILLINGPLAN",
  ProjectBillingPlan = "PROJECTBILLINGPLAN",
  ContractSLA = "CONTRACTSLA",
  ContractOption = "CONTRACTOPTION",
  ContractClin = "CONTRACTCLIN",
  ContractMilestone = "CONTRACTMILESTONE",
  ContractLaborCategory = "CONTRACTLABORCATEGORY",
  ContractClinFunding = "CONTRACTCLINFUNDING",
  ContractOptionFunding = "CONTRACTOPTIONFUNDING",
  Project = "PROJECT",
  ProjectTask = "PROJECTTASK",
  ProjectResource = "PROJECTRESOURCE",
  ProjectLaborCategory = "PROJECTLABORCATEGORY",
  ProjectMilestone = "PROJECTMILESTONE",
  BidRate = "BIDRATE"
}
